module.exports = __webpack_public_path__ + "img/agricultural_telehandlers.6a90fd7f.jpg";